export default {
  title: 'Varausilmoitukset',
  label: 'Mihin lähetämme varausilmoitukset?',
  placeholder: 'esim. bookings@ravintolasi.com',
  helper:
    'Mikä tahansa sähköposti käy — se ei vaadi hallintapaneelin kirjautumista. Voit muuttaa sitä tai lisätä lisää myöhemmin kohdassa Varaukset → Asetukset → Ilmoitukset ja vahvistus.',
  errors: {
    required: 'Lisää sähköposti, jotta varausilmoitukset tavoittavat sinut.',
    invalid: 'Anna kelvollinen sähköposti, esim. nimi@ravintola.com.',
  },
};
